import { createFileRoute } from '@tanstack/react-router';

import { CategoryFormScreen } from '@/features/catalog/CategoryForm';

/** Родитель из дерева: «+ подкатегория» открывает форму уже с ним. */
export interface NewCategorySearch {
  parent?: string;
}

/** Новая категория — отдельная страница. */
export const Route = createFileRoute('/_app/catalog_/categories_/new')({
  validateSearch: (search: Record<string, unknown>): NewCategorySearch => ({
    parent: typeof search.parent === 'string' && search.parent !== '' ? search.parent : undefined,
  }),
  component: NewCategoryRoute,
});

function NewCategoryRoute() {
  const { parent } = Route.useSearch();
  return <CategoryFormScreen defaultParentId={parent ?? ''} />;
}
